
type Props = {}

const Blocker = (props: Props) => {
  return (
    //2024-03-18  YAO 暫時拔除Loading...以解決翻譯問題
    <div></div>
  )
}

export default Blocker